/**
 * Entry point for the AI-agentic-testing layer. Dynamically imported from main.tsx
 * ONLY when agent mode is on (see agentMode.ts) — dev builds, `?agentMode=true`.
 * Docs for agents: ai-agentic-testing/README.md at the repo root.
 */
import { createAgentAuthApi, type AgentAuthApi } from './agentAuthApi'
import { installAgentVoiceApi, type AgentVoiceApi } from './agentVoiceApi'
import type { AgentGameApi } from './agentGameApi'

declare global {
  interface Window {
    __agentAuthApi?: AgentAuthApi
    __agentVoiceApi?: AgentVoiceApi
    __agentGameApi?: AgentGameApi
    __agentTesting?: { version: number }
  }
}

export const installAgentApis = (): void => {
  if (window.__agentTesting) return
  window.__agentTesting = { version: 1 }
  window.__agentAuthApi = createAgentAuthApi()
  installAgentVoiceApi()
  // __agentGameApi is installed by PlayGameUnity when the game iframe mounts.
  console.info('[agentTesting] agent APIs installed (__agentAuthApi, __agentVoiceApi; game API mounts with the game)')
}
